/**
 * @generated SignedSource<<2772dcf7b45641cec8bb67762d94eb71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteCapabilityInput = {
  id: any;
};
export type EditCapabilityDialogDeleteMutation$variables = {
  input: DeleteCapabilityInput;
};
export type EditCapabilityDialogDeleteMutation$data = {
  readonly deleteCapability: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type EditCapabilityDialogDeleteMutation = {
  response: EditCapabilityDialogDeleteMutation$data;
  variables: EditCapabilityDialogDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCapabilityPayload",
    "kind": "LinkedField",
    "name": "deleteCapability",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditCapabilityDialogDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditCapabilityDialogDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "05bf5cee8dc96c706f7614b82543b57b",
    "id": null,
    "metadata": {},
    "name": "EditCapabilityDialogDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation EditCapabilityDialogDeleteMutation(\n  $input: DeleteCapabilityInput!\n) {\n  deleteCapability(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "996782977c0609fc4ad0116822d52fae";

export default node;
